import { isDev } from '@/constants/env'
import router from '@/utils/router'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import type { HTMLAttributes } from 'react'

export interface DevToolsProps extends HTMLAttributes<HTMLDivElement> {}

export default function DevTools({ ...props }: DevToolsProps) {
	if (!isDev) return null

	return (
		<TanStackDevtools
			plugins={[
				{
					name: 'TanStack Query',
					render: <ReactQueryDevtoolsPanel />,
				},
				{
					name: 'TanStack Router',
					render: <TanStackRouterDevtoolsPanel router={router} />,
				},
			]}
		/>
	)
}
